export const useLocaleFormatting = () => {
  const { publicConfig } = useConfigStore();
  const configStore = useConfigStore();

  // Whole dollars render without cents ("$150"); anything fractional always gets two digits
  // ("$21.90", never "$21.9").
  const formatCurrency = (value: number) =>
    value.toLocaleString(publicConfig?.country.defaultLocale, {
      style: 'currency',
      currency: publicConfig?.country.currency,
      minimumFractionDigits: Number.isInteger(value) ? 0 : 2,
    })

  const formatNumber = (value: number, options?: Intl.NumberFormatOptions) =>
    value.toLocaleString(publicConfig?.country.defaultLocale, options)

  const formatDate = (value: string | Date, options?: Intl.DateTimeFormatOptions) =>
    new Intl.DateTimeFormat(publicConfig?.country.defaultLocale, options).format(new Date(value))

  // Handles raw numeric strings ("65000" → "$65K") and passes through pre-formatted strings ("$68k/year")
  const formatCompactWage = (wage: string | null | undefined): string | null => {
    if (!wage) {
      return null;
    }
    const value = Number.parseFloat(wage);
    if (Number.isNaN(value) || value <= 0) {
      return wage;
    }
    return new Intl.NumberFormat(configStore.publicConfig?.country.defaultLocale, {
      style: 'currency',
      currency: configStore.publicConfig?.country.currency ?? 'USD',
      notation: 'compact',
      maximumFractionDigits: 0,
    }).format(value);
  };

  return {
    formatCurrency,
    formatNumber,
    formatDate,
    formatCompactWage,
  };
}
